import Access from "../models/Access";
import ApiService from "./ApiService";
import Utils from "../utils/Utils";
import { SystemErrors } from "../definitions/systemErrors";

export default class AccessService {
  public static getListByCustomerId(customerId: string): Promise<Access[]> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/access/${customerId}`, "")
        .then((accessResult) => {
          if (!accessResult.data || accessResult.data.statusCode != SystemErrors.Authentication.Success || !accessResult.data.value) {
            resolve([]);
          } else {
            const items = accessResult.data.value.map((d: any) => {
              const data = { ...d };
              const item = { id: d.id, ...data } as Access;
              item.GrantedOn = data.GrantedOn ? Utils.vsDateToDatetime(data.GrantedOn) : null;
              item.RevokedOn = data.RevokedOn ? Utils.vsDateToDatetime(data.RevokedOn) : null;
              return item;
            });
            resolve(items);
          }
        })
        .catch((accessError) => {
          reject(accessError);
        });
    });
  }

  public static getList(): Promise<Access[]> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/access`, "")
        .then((accessResult) => {
          if (!accessResult.data || accessResult.data.statusCode != SystemErrors.Authentication.Success || !accessResult.data.value) {
            resolve([]);
          } else {
            const items = accessResult.data.value.map((d: any) => {
              const data = { ...d };
              const item = { id: d.id, ...data } as Access;
              item.GrantedOn = data.GrantedOn ? Utils.stringUtcToLocalDate(data.GrantedOn) : null;
              item.RevokedOn = data.RevokedOn ? Utils.stringUtcToLocalDate(data.RevokedOn) : null;
              return item;
            });
            resolve(items);
          }
        })
        .catch((accessError) => {
          reject(accessError);
        });
    });
  }

  public static create(model: Access): Promise<Access> {
    return new Promise((resolve, reject) => {
      ApiService.post("/access", model)
        .then((result) => {
          if (result.data) {
            model.id = result.data;
            resolve(model);
          }
        })
        .catch((addErr) => {
          reject(addErr);
        });
    });
  }

  public static grant(id: string, dt: Date | null = null): Promise<Date | null> {
    if (!dt) {
      const nowDate = new Date();
      dt = new Date(Date.UTC(nowDate.getUTCFullYear(), nowDate.getUTCMonth(), nowDate.getUTCDate(), nowDate.getUTCHours(), nowDate.getUTCMinutes()));
    }
    return new Promise((resolve, reject) => {
      ApiService.put("/access/grant", { id })
        .then((result) => {
          resolve(dt);
        })
        .catch((addErr) => {
          reject(addErr);
        });
    });
  }

  public static revok(id: string, dt: Date | null = null): Promise<Date | null> {
    if (!dt) {
      const nowDate = new Date();
      dt = new Date(Date.UTC(nowDate.getUTCFullYear(), nowDate.getUTCMonth(), nowDate.getUTCDate(), nowDate.getUTCHours(), nowDate.getUTCMinutes()));
    }
    return new Promise((resolve, reject) => {
      ApiService.put("/access/revoke", { id })
        .then((result) => {
          resolve(dt);
        })
        .catch((addErr) => {
          reject(addErr);
        });
    });
  }
}
